// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2VjEA","buttons":"styles_buttons__1-W8a"};